import React from "react";
import { Input } from "@/components/ui/input";

// A facilitator selector: pick from existing facilitators (auto-fills name + id)
// or choose "Custom name" to type a name for someone not yet in the system.
export function FacilitatorPicker({ facilitators = [], name = "", userId = null, onChange, testid = "facilitator-select" }) {
  const isCustom = !userId;

  const handleSelect = (e) => {
    const val = e.target.value;
    if (val === "__custom__") {
      onChange({ facilitator_name: "", facilitator_user_id: null });
    } else {
      const f = facilitators.find((x) => x.id === val);
      onChange({ facilitator_name: f ? f.name : "", facilitator_user_id: f ? f.id : null });
    }
  };

  return (
    <div className="space-y-2">
      <select
        data-testid={testid}
        value={userId || "__custom__"}
        onChange={handleSelect}
        className="w-full h-10 rounded-md border border-stone-200 bg-white px-3 text-sm text-stone-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#b81f24]/20 focus-visible:border-[#b81f24]"
      >
        <option value="__custom__">Custom name (not in system)</option>
        {facilitators.map((f) => (
          <option key={f.id} value={f.id}>{f.name} · {f.email}</option>
        ))}
      </select>
      {isCustom && (
        <Input
          data-testid={`${testid}-custom`}
          value={name}
          onChange={(e) => onChange({ facilitator_name: e.target.value, facilitator_user_id: null })}
          placeholder="Type facilitator name"
          className="h-10"
        />
      )}
    </div>
  );
}
